import { render, staticRenderFns } from "./EnvironmentInfo.vue?vue&type=template&id=e113a57a&scoped=true&"
import script from "./EnvironmentInfo.vue?vue&type=script&lang=js&"
export * from "./EnvironmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e113a57a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
